interface BreadcrumbItem {
  name: string;
  path: string;
}

const SITE_ORIGIN = "https://georgiadream.ge";

export function useBreadcrumbsLd(items: MaybeRefOrGetter<BreadcrumbItem[]>) {
  const localePath = useLocalePath();
  const route = useRoute();

  useHead(() => {
    const list = toValue(items);
    if (!list || list.length === 0) return {};
    // Match the `breadcrumb: { "@id": ... }` reference style used by page-level
    // WebPage @graph nodes (e.g. location.vue). Without this @id Google can't
    // resolve the reference across separate <script type="application/ld+json">
    // tags and reports "Missing field 'itemListElement'" against the dangling stub.
    const breadcrumbId = `${SITE_ORIGIN}${route.path}#breadcrumb`;
    return {
      script: [
        {
          type: "application/ld+json",
          innerHTML: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "@id": breadcrumbId,
            itemListElement: list.map((it, i) => ({
              "@type": "ListItem",
              position: i + 1,
              name: it.name,
              item: SITE_ORIGIN + localePath(it.path),
            })),
          }),
        },
      ],
    };
  });
}
